/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingunavailabledescription2Inputs */

const en_crosspostingunavailabledescription2 = /** @type {(inputs: Crosspostingunavailabledescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're rolling out the Facebook and Instagram integration right now. Check back shortly - your places and posts will be ready to go.`)
};

const de_crosspostingunavailabledescription2 = /** @type {(inputs: Crosspostingunavailabledescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir schalten die Facebook- und Instagram-Anbindung gerade frei. Schau in Kürze wieder vorbei – deine Orte und Beiträge sind dann sofort startklar.`)
};

/**
* | output |
* | --- |
* | "We're rolling out the Facebook and Instagram integration right now. Check back shortly - your places and posts will be ready to go." |
*
* @param {Crosspostingunavailabledescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingunavailabledescription2 = /** @type {((inputs?: Crosspostingunavailabledescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingunavailabledescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingunavailabledescription2(inputs)
	return de_crosspostingunavailabledescription2(inputs)
});
export { crosspostingunavailabledescription2 as "crosspostingUnavailableDescription" }